import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HOME',
    component: () => import('../components/Home.vue')
  },
  {
    path: '/login',
    name: 'LOGIN',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/categories',
    name: 'CATEGORIAS',
    component: () => import('../components/Categories.vue')
  },
  {
    path: '/products',
    name: 'PRODUCTOS',
    component: () => import('../components/Products.vue')
  },
  {
    path: '/vendors',
    name: 'VENDEDORES',
    component: () => import('../components/Vendors.vue')
  },
  {
    path: '/customers',
    name: 'CLIENTES',
    component: () => import('../components/Customer.vue')
  },


]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router